import { Component, OnInit } from '@angular/core';
import { PartnerService } from '../../../services/partner.service';

@Component({
  selector: 'app-partner-display-content',
  templateUrl: './partner-display-content.component.html',
  styleUrls: ['./partner-display-content.component.scss']
})
export class PartnerDisplayContentComponent implements OnInit {

  showProDetails: boolean;
  showShows: boolean;

  constructor(private partnerService: PartnerService) { }

  ngOnInit() {

    this.partnerService.showProDetails$.subscribe((x) => {
      this.showProDetails = x;
    });

    this.partnerService.showShows$.subscribe((x) => {
      this.showShows = x;
    });

  }
}
